/**
 * Fonction utilitaire pour obtenir l'URL de base sans le préfixe /api
 * Les images sont servies directement depuis /uploads/ et non depuis /api/uploads/
 */
export const getImageBaseUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  
  // Si l'URL contient /api/ quelque part, on le remplace par /
  if (apiUrl.includes('/api/')) {
    return apiUrl.replace('/api/', '/');
  }
  
  // Si l'URL se termine par /api, on l'enlève
  if (apiUrl.endsWith('/api')) {
    return apiUrl.slice(0, -4); // Enlever '/api'
  }
  
  return apiUrl;
};

/**
 * Fonction pour construire l'URL complète d'une image
 * @param {string} photo - Le nom du fichier photo ou une URL complète
 * @returns {string} L'URL complète de l'image
 */
export const getImageUrl = (photo) => {
  if (!photo) return null;
  if (photo.startsWith('http')) return photo;
  
  const baseUrl = getImageBaseUrl();
  return `${baseUrl}/uploads/${photo}`;
};

